import ClockModel from '@/models/ClockModel'

const emptyFilters = {
  type: undefined,
  content_type: undefined,
  date_from: undefined,
  date_to: undefined
}

const EVENT_RECEIVED_SCHEDULE = 'received_schedule'
const EVENT_DOWNLOAD_STARTED = 'download_started'
const EVENT_DOWNLOAD_COMPLETE = 'download_complete'
const EVENT_PLAYBACK = 'playback'
const EVENT_POWERPLAY = 'powerplay'
const EVENT_ADVERTISEMENT = 'advertisement'
const EVENT_PUBLIC_ANNOUNCEMENT = 'public_announcement'
const EVENT_REBOOT_SENT = 'reboot_sent'
const EVENT_FLASH_SENT = 'flash_sent'
const EVENT_FLASH_START = 'flash_start'
const EVENT_CONNECT = 'connect'
const EVENT_DISCONNECT = 'disconnect'
const EVENT_SSH_SENT = 'ssh_sent'
const EVENT_SSH_RESPONDED = 'ssh_responded'

const specs = {
  [EVENT_RECEIVED_SCHEDULE]: {
    key: EVENT_RECEIVED_SCHEDULE,
    text: 'Player received schedule',
    color: 'grey darken-1',
    icon: 'fa fa-tablet'
  },
  [EVENT_DOWNLOAD_STARTED]: {
    key: EVENT_DOWNLOAD_STARTED,
    text: 'Media download started',
    color: 'grey darken-1',
    icon: 'fa fa-tablet'
  },
  [EVENT_DOWNLOAD_COMPLETE]: {
    key: EVENT_DOWNLOAD_COMPLETE,
    text: 'Media download complete',
    color: 'grey darken-1',
    icon: 'fa fa-tablet'
  },
  [EVENT_PLAYBACK]: {
    key: EVENT_PLAYBACK,
    text: 'Music regular playback',
    color: ClockModel.colors[ClockModel.CONTENT_TYPE_MUSIC][ClockModel.PLAYBACK_TYPE_DEFAULT],
    icon: 'fa fa-play'
  },
  [EVENT_RECEIVED_SCHEDULE]: {
    key: EVENT_RECEIVED_SCHEDULE,
    text: 'Player received schedule',
    color: 'grey darken-1',
    icon: 'fa fa-tablet'
  },
  [EVENT_POWERPLAY]: {
    key: EVENT_POWERPLAY,
    text: 'Music powerplay',
    color: ClockModel.colors[ClockModel.CONTENT_TYPE_MUSIC][ClockModel.PLAYBACK_TYPE_AFTER_SONGS],
    icon: 'fa fa-play'
  },
  [EVENT_ADVERTISEMENT]: {
    key: EVENT_ADVERTISEMENT,
    text: 'Advertisement playback',
    color: ClockModel.colors[ClockModel.CONTENT_TYPE_MARKETING][ClockModel.PLAYBACK_TYPE_AFTER_MINUTES],
    icon: 'fa fa-play'
  },
  [EVENT_PUBLIC_ANNOUNCEMENT]: {
    key: EVENT_PUBLIC_ANNOUNCEMENT,
    text: 'Public announcement playback',
    color: ClockModel.colors[ClockModel.CONTENT_TYPE_PA][ClockModel.PLAYBACK_TYPE_DEFAULT],
    icon: 'fa fa-play'
  },
  [EVENT_REBOOT_SENT]: {
    key: EVENT_REBOOT_SENT,
    text: 'Reboot command',
    color: 'grey darken-1',
    icon: 'fa fa-user-cog'
  },
  [EVENT_FLASH_SENT]: {
    key: EVENT_FLASH_SENT,
    text: 'Flash command',
    color: 'grey darken-1',
    icon: 'fa fa-user-cog'
  },
  [EVENT_FLASH_START]: {
    key: EVENT_FLASH_START,
    text: 'Player started flashing',
    color: 'grey darken-1',
    icon: 'fa fa-tablet'
  },
  [EVENT_CONNECT]: {
    key: EVENT_CONNECT,
    text: 'Player connected',
    color: 'grey darken-1',
    icon: 'fa fa-tablet'
  },
  [EVENT_DISCONNECT]: {
    key: EVENT_DISCONNECT,
    text: 'Player disconnected',
    color: 'grey darken-1',
    icon: 'fa fa-tablet'
  },
  [EVENT_SSH_SENT]: {
    key: EVENT_SSH_SENT,
    text: 'SSH connect command',
    color: 'grey darken-1',
    icon: 'fa fa-user-cog'
  },
  [EVENT_SSH_RESPONDED]: {
    key: EVENT_SSH_RESPONDED,
    text: 'Player sent SSH connection data',
    color: 'grey darken-1',
    icon: 'fa fa-tablet'
  }
}

export default {
  emptyFilters,
  eventSpecs: specs
}
